import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button } from "discover.medical.react-component-library";
import { orgFreeTrial, freeTrialPlan } from "../../utils/constants";
import { productNames } from "../../constants/appData";
import {
  ECOMMERCE_FREE_TRIAL_VIEWED,
  ECOMMERCE_PRODUCT_SELECTED,
} from "../../telemetry/constants";
import { handleAnalyticsConsent } from "../../osano";
import { log } from "../../telemetry/analytics";
import "./styles.css";

const FreeTrial = ({ productCode }) => {
  useEffect(() => {
    handleAnalyticsConsent(() => {
      log(ECOMMERCE_FREE_TRIAL_VIEWED, {});
    });
  }, []);

  const handleFreeTrialClick = () => {
    if (window.Osano && window.Osano.cm.analytics) {
      log(ECOMMERCE_PRODUCT_SELECTED, {
        id: freeTrialPlan.id,
        price: freeTrialPlan.price,
        name: freeTrialPlan.description,
      });
    }
  };
  return (
    <div>
      <div className="mb-4 block-center text-left text-sm-center">
        <h1
          className="text-center free-trial-header"
          data-auto="free-trial-main-header"
        >
          We deliver unparalleled, evidence-based guidance to practicing
          clinicians.
        </h1>
      </div>
      <div className="free-plan-wrapper">
        <div className="free-plan-block mb-3 col-12 col-sm-8 col-lg-4">
          <div className="free-plan d-flex justify-content-between flex-column block-center">
            <h6 className="text-center">Try a FREE 14-Day individual trial.</h6>
            <div className="block-center">
              <ul className="description" data-auto="description">
                <li>
                  <strong>No credit card</strong> required
                </li>
                <li>
                  <strong>Fast & easy</strong> sign up
                </li>
                <li>
                  <strong>Full and free access</strong>
                  {` to ${productNames[productCode]} for 14 days`}
                </li>
                <li>
                  <strong>Includes access via the app</strong> (iOS and Android)
                </li>
              </ul>
            </div>
            <div className="text-center">
              <Button
                href="/store/free-trial/checkout"
                className="free-trial-button"
                data-auto="free-trial-button"
                onClick={handleFreeTrialClick}
              >
                Start my FREE Trial
              </Button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center free-trial-footer">
        <span className="free-trial-org">
          Want a free trial for your organization?
        </span>{" "}
        <a href={orgFreeTrial[productCode]}>Apply here</a>
      </p>
    </div>
  );
};

export const mapStateToProps = ({ productInfo }) => ({
  productCode: productInfo.productCode,
});

export default connect(mapStateToProps)(FreeTrial);
